import { PerformanceDatapoint } from 'owa-analytics';
import { getTaskFoldersService } from 'owa-todo-service';
import { logUsage } from 'owa-analytics';
import { Datapoints, PerformanceDatapointCheckmarks } from '../datapoints';
import { processLoadedFolders } from '../actions/todoFolderStoreActions';

export async function loadFolders(perfDatapoint?: PerformanceDatapoint) {
    const folders = await getTaskFoldersService();
    if (perfDatapoint) {
        perfDatapoint.addCheckmark(PerformanceDatapointCheckmarks.fetchedTaskFolders);
    }

    processLoadedFolders(folders);
    if (perfDatapoint) {
        perfDatapoint.addCheckmark(PerformanceDatapointCheckmarks.processedTaskFolders);

        // We only want to log metadata metric only for explicit loads, not a preload.
        // perfDatapoint is set to non-null only for these explicit loads.
        logUsage(
            Datapoints.todoMetaDataFolder.name,
            Datapoints.todoMetaDataFolder.customData(),
            Datapoints.todoMetaDataFolder.options
        );
    }
}
